const getAmazonLpClientdId = (): string =>
    window.dazn.features.getVariableStringAnonymous(
        'f_ar_landingpages_showlwapage',
        'ClientID'
    ) ?? 'amzn1.application-oa2-client.f0b29fe5c2e44e3e836b1edf7af6b731';


export { getAmazonLpClientdId }